import React from 'react'
import classnames from 'classnames'

import { Box, CustomizableDashboard } from '@domain-group/suit-theme'

import styles from './styles.module.scss'

interface ContentProps {
  draggablePlaceholder?: object,
  id?: string,
  isDraggingOver?: boolean,
  modules?: { key: string, moduleId: string }[],
}

const Content = React.forwardRef((props: ContentProps, ref) => {
  const {
    draggablePlaceholder, id, isDraggingOver, modules,
  } = props

  return (
    <Box
      className={classnames(styles.root, isDraggingOver ? styles.draggingOver : null)}
      flexDirection="column"
      marginRight={[0, 0, 'large']}
      width={['100%', '100%', 'calc(100% - 375px)']}
    >
      {/*
       // @ts-expect-error TS2322 */}
      <div ref={ref} style={{ flexGrow: 1, minHeight: '100vh' }}>
        {/*
         // @ts-expect-error TS2786 */}
        {modules && <CustomizableDashboard.ModuleRenderer modules={modules} parentId={id} />}
        {draggablePlaceholder}
      </div>
    </Box>
  )
})

export default Content
